import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'antd';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { HolderOutlined, MinusCircleOutlined } from '@ant-design/icons';
import ProblemTypeHierarchicalDisplay from '../problem_type_hierarchical_display/ProblemTypeHierarchicalDisplay';

const style = require('./ApprovalHierarchyRowDisplay.less');

function ApprovalHierarchyRowDisplay(props) {
	const { id, approvalHierarchy, rank } = nullSafeGetOrElse('record', props, {});
	const {
		isCapex,
		isPM,
		woPriorities,
		problemTypeIds,
		locations,
		stockLocations,
		fieldTechEmails,
	} = nullSafeGetOrElse('record', props, {});
	const { type, autoApproveServiceRequests, userType } = props;

	const conditions = [
		{
			name: 'Expenditure Type',
			value: isCapex === undefined ? undefined : isCapex ? 'CapEx' : 'R&M',
		},
		{
			name: 'Work Order Type',
			value: isPM === undefined ? undefined : isPM ? 'Planned' : 'Reactive',
		},
		{
			name: 'Work Order Priorities',
			value:
				woPriorities === undefined || woPriorities.length === 0
					? undefined
					: woPriorities.map((val) => val.name),
		},
		{
			name: 'Work Order Problem Types',
			value:
				problemTypeIds === undefined || problemTypeIds.length === 0 ? undefined : (
					<ProblemTypeHierarchicalDisplay problemTypeIds={problemTypeIds} displayMode="pill" />
				),
		},
		{
			name: 'Locations',
			value:
				locations === undefined || locations.length === 0
					? undefined
					: locations.map((val) => val.name),
		},
		{
			name: 'Stock Locations',
			value:
				stockLocations === undefined || stockLocations.length === 0
					? undefined
					: stockLocations.map((val) => val.name),
		},
		{
			name: 'Field Technicians',
			value:
				fieldTechEmails === undefined || fieldTechEmails.length === 0 ? undefined : fieldTechEmails,
		},
	];
	const conditionDisplay = conditions
		.filter((rule) => rule.value !== undefined && rule.value !== [])
		.map((rule, i, rules) => (
			<Row className={'flex'}>
				<Col className={'flex pr-1'} style={{ fontWeight: 600 }}>
					{rule.name}
				</Col>
				<Col className={'flex pr-1'}>is</Col>
				<Col className={'flex'} style={{ fontStyle: 'italic' }}>
					{Array.isArray(rule.value) ? rule.value.join(', ') : rule.value}
				</Col>
				{rules.length - 2 > i ? (
					','
				) : rules.length - 1 > i ? (
					<Col className={'flex pl-1'}>and</Col>
				) : null}
			</Row>
		));

	return props.isDefault ? (
		<Row
			className={'draggable-item flex w-full items-center justify-between gap-12 px-2 py-4'}
			style={{ borderBottom: '1px solid rgb(240,240,240)' }}
		>
			<Col className={'flex w-4'} />
			<Col className={'flex w-5'} />
			<Col className={'flex w-28'}>Everything {props.rules.length > 0 ? 'else' : ''}</Col>
			<Col className={'flex w-64'} />
			<Col className={'ml-7 flex w-20'}>uses</Col>
			<Col className={'flex flex-grow'}>
				{id ? (
					<a
						href={`/${userType}/approvalHierarchies/detail/templates/${nullSafeGet(
							'id',
							approvalHierarchy
						)}/details`}
						target="_blank"
						rel="noreferrer"
					>
						{nullSafeGet('name', approvalHierarchy)}
					</a>
				) : type === 'workOrder' ? (
					autoApproveServiceRequests ? (
						`Auto-Approval`
					) : (
						`Facility Contacts (Access Control)`
					)
				) : (
					`Access Control`
				)}
			</Col>
			<Col>
				<Button onClick={() => props.edit()}>Edit</Button>
			</Col>
			{id ? (
				<div
					onClick={props.delete}
					className={'x'}
					style={{
						display: 'flex',
						border: 'none',
						boxShadow: 'none',
						outline: 'none',
					}}
				>
					<MinusCircleOutlined translate="" className="dynamic-delete-button" />
				</div>
			) : (
				<div style={{ width: 32 }}></div>
			)}
		</Row>
	) : (
		<Row
			className={'draggable-item flex w-full items-center justify-between gap-12 px-2 py-4'}
			style={{ borderBottom: '1px solid rgb(240,240,240)' }}
		>
			<Col key={`step-${id}`} className={'flex w-4'}>
				<HolderOutlined className="icon" translate={undefined} />
			</Col>
			<Col key={`rank-${id}`} className={'flex w-5'}>
				{rank}
			</Col>
			<Col className={'flex w-3'}>If</Col>
			<Col key={`conditions-${id}`} className={'flex w-96 flex-col'}>
				{conditionDisplay}
			</Col>
			<Col className={'flex w-20'}>then use</Col>
			<Col className={'flex flex-grow'}>
				<a
					href={`/${userType}/approvalHierarchies/detail/templates/${nullSafeGet(
						'id',
						approvalHierarchy
					)}/details`}
					target="_blank"
					rel="noreferrer"
				>
					{nullSafeGet('name', approvalHierarchy)}
				</a>
			</Col>
			<Col>
				<Button onClick={() => props.edit()}>Edit</Button>
			</Col>
			<div
				onClick={props.delete}
				className={'x'}
				style={{
					display: 'flex',
					border: 'none',
					boxShadow: 'none',
					outline: 'none',
				}}
			>
				<MinusCircleOutlined translate="" className="dynamic-delete-button" />
			</div>
		</Row>
	);
}
const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	userType: state.session.userType,
	stockLocations: state.stock_locations,
});
const mapDispatchToProps = (dispatch, ownProps) => ({});

const ApprovalHierarchyRowDisplayWR = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ApprovalHierarchyRowDisplay)
);
export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ApprovalHierarchyRowDisplayWR);
